module.exports = __webpack_public_path__ + "static/img/9.1c626fd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/3/1/sp/9.png
// module id = JHXy
// module chunks = 0